'use strict';

var React = require('react'),
    _ = require('underscore'),
    FormMixin = require('../mixins/FormMixin'),
    FormInputRow = require('../molecules/FormInputRow'),
    ServiceAccountRow = require('../molecules/ServiceAccountRow'),
    NotificationSwitchRow = require('../molecules/NotificationSwitchRow'),
    Textarea = require('../atoms/Textarea'),
    Link = require('../atoms/Link'),
    Icon = require('../atoms/Icon'),
    Button = require('../atoms/Button'),
    BtnGroup = require('../molecules/BtnGroup'),
    ImagePicker = require('../organisms/ImagePicker'),
    TabBar = require('../molecules/TabBar'),
    TabLink = require('../atoms/TabLink'),
    validateEmail = require('../utils/validateEmail'),
    UserStore = require('../stores/UserStore'),
    ServiceAccountStore = require('../stores/ServiceAccountStore'),
    createStoreMixin = require('../mixins/createStoreMixin'),
    getUserThumbnail = require('../utils/getUserThumbnail'),
    getThumbnailUrl = require('../utils/getThumbnailUrl'),
    UserActionCreators = require('../actions/UserActionCreators'),
    PureRenderMixin = require('../mixins/PureRenderMixin'),
    EmailFlags = require('../constants/EmailFlags'),
    keyMirror = require('react/lib/keyMirror'),
    { PropTypes } = React;

var TABS = keyMirror({
  GENERAL: null,
  ACCOUNT: null,
  SOCIAL: null,
  NOTIFICATIONS: null
});

var Settings = React.createClass({
  mixins: [FormMixin, createStoreMixin(UserStore, ServiceAccountStore), PureRenderMixin],

  propTypes: {
    initialTabId: PropTypes.string,
    onCloseClick: PropTypes.func.isRequired
  },

  getInitialState() {
    return {
      activeTabId: this.props.initialTabId || TABS.GENERAL
    };
  },

  getStateFromStores() {
    var user = UserStore.getMe(),
        fields;

    fields = _.flatten(_.map(
      [TABS.ACCOUNT, TABS.GENERAL, TABS.SOCIAL],
      this.getTabFields
    ));

    return _.extend({
      user: user,
      dummyPassword: '********',
      showChangePassword: false,
      password: '',
      confirmPassword: ''
    }, _.pick(user, fields));
  },

  getTabs: function () {
    return [{
      id: TABS.GENERAL,
      title: 'Info'
    }, {
      id: TABS.ACCOUNT,
      title: 'Account'
    }, {
      id: TABS.SOCIAL,
      title: 'Services'
    }, {
      id: TABS.NOTIFICATIONS,
      title: 'Notifications'
    }];
  },

  getTabFields: function (tabId) {
    var fields = ['thumbnailUrl'];

    switch (tabId) {
    case TABS.GENERAL:
      fields = fields.concat(['name', 'about', 'location', 'website']);
      break;
    case TABS.ACCOUNT:
      fields = fields.concat(['email', 'confirmedEmail']);
      if (this.state && this.state.password) {
        fields = fields.concat(['oldPassword', 'password']);
      }
      break;
    }

    return fields;
  },

  getThumbnailUrl: function () {
    const devicePixelRatio = (typeof window !== 'undefined') ? window.devicePixelRatio : 1;

    var size = 6 * 16 * Math.round(devicePixelRatio),
        image;

    if (this.state.thumbnailUrl) {
      image = { url: this.state.thumbnailUrl };
    } else {
      image = getUserThumbnail(this.state.user);
    }

    return getThumbnailUrl(image, {
      allowExternal: true,
      mode: 'scale_crop',
      width: size,
      height: size
    });
  },

  componentDidUpdate(prevProps, prevState) {
    if (prevState.activeTabId === TABS.ACCOUNT &&
        this.state.activeTabId !== TABS.ACCOUNT &&
        !this.state.password) {

      this.setState({
        showChangePassword: false
      });
    }
  },

  render: function () {
    const { activeTabId } = this.state;
    const footer = this.renderFooter(activeTabId);

    return (
      <div className='Modal-body Modal-body--wide'>
        <div className='Modal-header'>
          <h3 className='Modal-title'>
            Settings
          </h3>
          <div onTouchTap={_.partial(this.props.onCloseClick, false)}
               className='Modal-close'>
            <Icon name='cross' size='small' mode='stroke' />
          </div>
        </div>

        <div className='Modal-content'>
          <ImagePicker imageUrl={this.getThumbnailUrl()}
                       size='avatar'
                       onUploadSuccess={this.handleAvatarUploaded}
                       cancelOnChange>
            <Icon name='image'
                  size='medium'
                  mode='stroke' />
          </ImagePicker>

          <div className='Modal-tabs'>
            <TabBar>
              {this.getTabs().map(tab =>
                <TabLink key={tab.id}
                         active={tab.id === activeTabId}
                         onClick={() => this.handleTabClick(tab.id)}>
                  {tab.title}
                </TabLink>
              )}
            </TabBar>
          </div>

          {this.renderTab(activeTabId)}
        </div>

        {footer &&
          <div className='Modal-footer'>
            {footer}
          </div>
        }
      </div>
    );
  },

  handleTabClick(tabId) {
    this.setState({
      activeTabId: tabId
    });
  },

  handleAvatarUploaded: function (filePath, image) {
    if (this.isMounted()) {
      this.setState({
        thumbnailUrl: image.url
      });
    }
  },

  renderTab: function (tabId) {
    switch (tabId) {
    case TABS.GENERAL:
      return (
        <div key='general'>
          <div className='Form'>
            <FormInputRow label='Name'
                          formLink={this.linkValidatedState('name', this.validateName)} />

            <FormInputRow component={Textarea}
                          label='Short Bio'
                          formLink={this.linkValidatedState('about', this.validateAbout)} />

            <FormInputRow label='Location'
                          formLink={this.linkState('location')} />

            <FormInputRow label='Website'
                          formLink={this.linkState('website')} />
          </div>
        </div>
      );

    case TABS.ACCOUNT:
      var showChangePassword = this.state.showChangePassword;

      return (
        <div key='account'>
          <div className='Form'>
            <FormInputRow label='Email Address'
                          formLink={this.linkValidatedState('email', validateEmail)} />
            {!showChangePassword && <FormInputRow label='Password'
                          key='focus-password'
                          type='password'
                          formLink={this.linkState('dummyPassword')}
                          onFocus={this.handleChangePasswordClick} />}
            {showChangePassword && <FormInputRow label='Old Password'
                          key='focus-password'
                          type='password'
                          formLink={this.linkValidatedState('oldPassword', this.validateOldPassword)} />}
            {showChangePassword && <FormInputRow label='New Password'
                          type='password'
                          formLink={this.linkValidatedState('password', this.validatePassword)} />}
            {showChangePassword && <FormInputRow label='New Password, Again'
                          type='password'
                          formLink={this.linkValidatedState('confirmPassword', this.validateConfirmPassword)} />}
          </div>
        </div>
      );

    case TABS.SOCIAL:
      var userId = this.state.user.id,
          serviceAccounts = ServiceAccountStore.getUserServiceAccounts(userId),
          authServiceAccounts = ServiceAccountStore.getConnectedAuthServiceAccounts(userId),
          allowDisconnectAuthService;

      allowDisconnectAuthService = authServiceAccounts.length > 1 || this.state.user.hasPassword;

      return (
        <div key='social'>
          <div className='Form'>
            {_.map(serviceAccounts, function (acc, key) {
              return <ServiceAccountRow key={key}
                                        serviceType={key}
                                        formLink={this.linkState(key.toLowerCase())}
                                        allowDisconnect={allowDisconnectAuthService || !ServiceAccountStore.isAuthService(userId, key)} />;
            }.bind(this))}
          </div>
        </div>
      );

    case TABS.NOTIFICATIONS:
      return (
        <div key='notifications'>
          <p className='Modal-message'>Choose when Stampsy sends you emails.</p>
          <div className='Form'>
            <NotificationSwitchRow flag={EmailFlags.STAMP_PUBLISHED}
                                   label='Your stamp is posted' />

            <NotificationSwitchRow flag={EmailFlags.TRENDING_STAMP}
                                   label='Your stamp is trending' />

            <NotificationSwitchRow flag={EmailFlags.NEW_SUBSCRIBER}
                                   label='Somebody follows you or your collections' />

            <NotificationSwitchRow flag={EmailFlags.YOUR_STAMP_ADDED_TO_COLLECTION}
                                   label='Your stamp is added to a collection' />

            <NotificationSwitchRow flag={EmailFlags.STAMP_SUBMITTED_TO_COLLECTION}
                                   label='A stamp is submitted to your collection' />

            <NotificationSwitchRow flag={EmailFlags.SUBMISSION_APPROVED_OR_DECLINED}
                                   label='Your submission to another collection is approved or declined' />

            <NotificationSwitchRow flag={EmailFlags.COLLECTED_IMAGE_PUBLISHED}
                                   label='Your image gets credited in other stamp' />

            <NotificationSwitchRow flag={EmailFlags.DRAFT_FEEDBACK}
                                   label='Someone leaves feedback on your draft' />

            <NotificationSwitchRow flag={EmailFlags.WEEKLY_PENDING_REMINDER}
                                   label='Weekly reminder about submissions to your collections' />

            <NotificationSwitchRow flag={EmailFlags.WEEKLY_DIGEST_AND_MISC}
                                   label='Weekly digest with best stamps and Stampsy updates' />
          </div>
        </div>
      );
    }
  },

  renderFooter: function (tabId) {
    if (!this.isSaveButtonVisible(tabId)) {
      if (tabId === TABS.ACCOUNT) {
        return (<p className='Modal-message'><a className="Link Link--red Link--bold Link--underlineHover" href="/account/delete">Delete my Stampsy account</a></p>);
      }

      return;
    }

    return (
      <BtnGroup>
        <Button size='large'
                color='green'
                onClick={this.handleSubmitClick.bind(this, tabId)}>
          Save Changes
        </Button>
        <Button size='large'
                color='gray'
                onClick={_.partial(this.rollbackChanges.bind(this, tabId), false)}>
          Cancel
        </Button>
      </BtnGroup>
    );
  },

  rollbackChanges: function (tabId) {
    var fields = this.getTabFields(tabId),
        newState = _.pick(this.state.user, fields);

    if (tabId === TABS.ACCOUNT) {
      _.extend(newState, {
        password: '',
        confirmPassword: '',
        showChangePassword: false
      });
    }

    this.setState(newState);
  },

  isSaveButtonVisible: function (tabId) {
    if (!this.isFormEditable()) {
      return false;
    }

    var fields = this.getTabFields(tabId),
        values = _.pick(this.state, fields);

    return _.any(values, this.hasValueChanged);
  },

  hasValueChanged: function (newValue, key) {
    newValue = newValue || '';
    var oldValue = this.state.user[key] || '';
    return oldValue !== newValue;
  },

  handleChangePasswordClick: function () {
    this.setState({
      showChangePassword: true
    }, function () {
      this.validateFields(['oldPassword'], {
        showHelp: true
      });
    }.bind(this));
  },

  handleSubmitClick: function (tabId) {
    this.submitForm(this.sendRequest.bind(this, tabId));
  },

  validateOldPassword: function (oldPassword) {
    oldPassword = (oldPassword || '').trim();

    if (this.state.password && !oldPassword) {
      return {
        error: 'Required'
      };
    }

    return {
      permanentHelp: <Link color='gray' onClick={this.handleResetPasswordClick}>Forgot your password?</Link>
    };
  },

  handleResetPasswordClick: function () {
    UserActionCreators.requestResetPassword();
  },

  validatePassword: function (password) {
    password = (password || '').trim();

    if (password && password.length < 8) {
      return {
        error: 'Minimum 8 characters'
      };
    }
  },

  validateConfirmPassword: function (confirmPassword) {
    confirmPassword = (confirmPassword || '').trim();

    if (!confirmPassword && !this.state.password) {
      return;
    }

    if (confirmPassword !== this.state.password) {
      return {
        error: 'Password doesn’t match'
      };
    }
  },

  validateName: function (name) {
    name = (name || '').trim();
    if (!name) {
      return {
        error: 'Required'
      };
    }

    if (name.length < 3) {
      return {
        error: 'Minimum three characters'
      };
    }
  },

  validateAbout: function (about) {
    var charsLeft = 140 - (about || '').length;

    return {
      help: charsLeft.toString(),
      error: charsLeft < 0 && charsLeft.toString()
    };
  },

  sendRequest: function (tabId) {
    var fields = this.getTabFields(tabId),
        data;

    data = _.pick(this.state, fields);
    UserActionCreators.saveSettings(data);
  }
});

module.exports = Settings;



/** WEBPACK FOOTER **
 ** ./modals/Settings.jsx
 **/